import React, { useState, useEffect } from 'react';
import Yellowbox from './Yellowbox/Yellobox.jsx';
import Greenbox from './Greenbox/Greenbox.jsx';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { get_apps, get_login,user_profile } from '../../api/api.js';
import { useMediaQuery } from 'react-responsive';
import { TbMoodSad } from "react-icons/tb";

function Temporaryblankbox(props) {
  const [userApps, setUserApps] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const [usrAppsNotify, setUserAppsNotify] = useState('');
  const isMobile = useMediaQuery({ query: '(max-width: 950px)' });

 /*
  const getuserapps = async () => {
    const response = await user_profile();
    console.log('Response from new API ',response)
   if (response.status === 200 && response.apps.length > 0) {
      const appnames = response.data.map((item, i) => ({
        key: i,
        label: item.appname,
        value: item.applogo,
        url: item.appurl,
      }));
      setUserApps(appnames);
      setItemCount(response.data.length); // Set item count
    }else if(response.data.length===0){
      setUserAppsNotify(response.message)
    }
  };*/
 const getuserapps = async () => {
    try {
        const response = await user_profile();
                     

        


        if (response.status === 200 && response.data.apps.length > 0) {
            const appnames = response.data.apps.map((item, i) => ({
                key: i,
                label: item.appname,
                value: item.applogo,  // Updated to use `applogo` instead of `logo`
                url: item.appurl,
            }));

            
            
            setUserApps(appnames);
	           console.log('User Apps ',userApps)
            setItemCount(response.apps.length); // Set item count
        } else if (response.apps.length === 0) {
            setUserAppsNotify(response.message);
        }
    } catch (error) {
        console.error('Error fetching user apps:', error);
        setUserAppsNotify("Failed to fetch user apps.");
    }
};

  const slideLeft = () => {
    var slider = document.getElementById('slider');
    slider.scrollLeft = slider.scrollLeft - 200;
  };

  const slideRight = () => {
    var slider = document.getElementById('slider');
    slider.scrollBy({
      top: 0,
      left: 400, // Adjust the value as needed
      behavior: 'smooth', // This enables smooth scrolling
    });
  };

  useEffect(() => {
    getuserapps();
  }, []);

  return (
    <div className='maincontainer'>
  {userApps.length === 0 ? (
    <div className="Mid">
      <div className="noapps" style={{display:'flex',justifyContent:'center', width:'100%', height:'50px',
        marginLeft:'-25px', position:'justify', fontSize:'25px', fontWeight:'600'
      }}>
      <span><TbMoodSad style={{height:'auto',width:'400px'}}/></span>        
      </div>
    </div>
  ) : (
    userApps.length > 4 || isMobile ? (
      <div className="Mid">
        <MdChevronLeft className="arrowIcon" onClick={slideLeft} size={40} />
        <div
          id="slider"
          className="hover:scrollbar-thumb-neutral-300 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar scrollbar-thumb-neutral-200 scrollbar-track-green-99 overflow-x-scroll mb-50"
        >
          {userApps.map((app, i) => (
            <div key={i} className='mb-20'>
              {i % 2 == 0 ? (
                <Greenbox
                  keyno={i}
                  imageSrc={`data:image/png;base64,${app.value}`}
                  applink={app.url}
                  applength={userApps.length}
                />
              ) : (
                <Yellowbox
                  keyno={i}
                  imageSrc={`data:image/png;base64,${app.value}`}
                  applink={app.url}
                  applength={userApps.length}
                />
              )}
            </div>
          ))}
        </div>
        <MdChevronRight className="arrowIcon" onClick={slideRight} size={20} />
      </div>
    ) : (
      <div className="Mid">
        <div className="blankbox centerizeboxes">
          {userApps.map((app, i) => (
            <div key={i}>
              {i % 2 === 0 ? (
                <Greenbox
                  keyno={i}
                  imageSrc={`data:image/png;base64,${app.value}`}
                  applink={app.url}
                  applength={userApps.length}
                />
              ) : (
                <Yellowbox
                  keyno={i}
                  imageSrc={`data:image/png;base64,${app.value}`}
                  applink={app.url}
                  applength={userApps.length}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    )
  )}
</div>
  );
  
}

export default Temporaryblankbox;
